import MainNav from '../components/MainNav';
import MainFooter from '../components/MainFooter';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const NewsletterApril2026Page = () => {
    const newsletter = {
        month: 'April 2026',
        volume: 'Volume 1, Issue 13',
        title: 'R&R News',
        tagline: 'In all that you do, spring forward.',
        founderImage: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/9yd1oqav_unnamed.jpg',
        foundersDesk: `Brothers,

As we continue through the month of April, we welcome not just a new month, but the spirit of renewal that spring brings 🌱. This season reminds us that growth is ongoing, fresh starts are always within reach, and what we nurture with intention will continue to evolve. It's a time to reset, refocus, and recommit to becoming our best selves—more present, more grounded, and more aligned with purpose ✨.

The work of Recovery Room continues to take shape in meaningful ways. What we are building is not happening overnight. It is intentional, steady, and rooted in laying a strong foundation from the ground up.

Leadership Lives Here 💪🏾

I want to extend my sincere gratitude to every brother who has stepped up to lead one of our new volunteer R&R Committees. As I've said time and time again, this is not my organization—it's ours. This work only moves forward because of each of you. Each one, reach one, teach one remains our guiding principle, and I couldn't be more proud to welcome our new Committee Chairmembers who will help shape the future of Recovery Room over the next year:

• Reginald Ready (Recruitment)
• Kmt Shockley, PhD (Community Engagement)
• Orlance Shirley (Mentorship)
• Anthony Carter (Professional Development)
• Ihkeem Ma'at (IT/Marketing)
• Herman Pryor Jr., Ed.D. (Fundraising)

Please join me in congratulating these outstanding men for their commitment to our mission and their partnership in supporting the continued journey of the brothers of Recovery Room! I challenge every brother to support a committee of interest as you continue to navigate your purpose in this space (reach out to the committee chair for more info). Your support and efforts are greatly appreciated in advance.

Let's keep building together. In brotherhood, growth, and purpose.

With appreciation,

Herman I. Pryor, Jr., Ed.D.
Founder, Recovery Room`,
        sections: [
            {
                title: "R&R Saturdays - April Recap",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/2u34wfrg_unnamed%20%281%29.jpg',
                content: `Our April R&R Saturdays gathering was a powerful reminder of what intentional space can create. To all the new brothers who joined us for the first time—welcome. Your presence added real value to the circle, and it meant a lot to see so many new faces step into the space. Moments like this affirm that if you build it with intention and it resonates, they will come.

It reinforces our commitment to continuing to offer a safe space where Black men can realign, recharge, and simply be. We've been intentional about cultivating this environment, and it's clear that it's taking shape in all the right ways.

A special thank you to everyone who contributed to the food and comradery. It truly elevated the experience and is deeply appreciated. Looking forward to reconnecting with you in May!

On to May.

Next Gathering: May 2026

Join us on Saturday, May 2, 2026 for more great connection, collectivism, and commitment to self and community. We're challenging each brother to invite someone new in May. See you there!

📅 Saturday, May 2, 2026
🕠 5:30pm - 8pm

Please RSVP below, and feel free to invite another brother to join you. Together, let's continue strengthening our community, one connection at a time.`
            },
            {
                title: "ARE YOU FOLLOWING US on Instagram and Facebook????",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/5gbqrc46_unnamed%20%282%29.jpg',
                content: `We've officially expanded our community presence, and we'd love for you to stay connected with us in real time!

Our Recovery Room Instagram page is live. We've created a space to share inspiration, upcoming events, wellness insights, and moments from our gatherings that remind us of the power of brotherhood.

Follow us on Instagram @recoveredbrother and join the conversation as we continue to grow, uplift, and connect beyond our in-person sessions.

See you there, brothers!`
            },
            {
                title: "HIGHLIGHT a BROTHER",
                subtitle: "Meet Orlance Shirley",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/pz1c28j5_unnamed%20%283%29.jpg',
                content: `Interests: Wellness & Healing | Mentorship
Profession: Supervisory Program Analyst, Department of Homeland Security

Originally from Los Angeles, CA, Lance is now based in Washington, D.C., where he serves in a leadership capacity within the Federal Government, supporting teams at the Department of Homeland Security. A skilled project manager and team-oriented leader, Lance brings a collaborative approach to his work. He is excited to support R&R's newly formed Mentorship Committee and is excited to contribute a strong background in cultural programming and development to the continued growth of Recovery Room.

How long have you been part of the Recovery Room?
I've been engaged since October 2025.

What has been the biggest impact for you?
The inspiration that comes from the space has been the biggest benefit. Everyone is committed to fostering a supportive environment, and Black men often don't have access to those, especially amongst each other.

What keeps you coming back?
I really see it as a privilege to have found the Recovery Room, and I find myself leaving the sessions feeling empowered and motivated to be a better version of myself.

Any advice for the brothers?
My advice would be to abandon the crabs in a barrel mindset. We've been conditioned to see each other as competition, and this, in my opinion, is one of the biggest barriers to collective advancement.

Anything you'd like to offer the community?
My favorite African proverb is "If you want to go fast, go alone. If you want to go far, go together."

— To connect with Orlance Shirley, contact him at: a4lance@gmail.com`
            },
            {
                title: "COMMUNITY UPDATES",
                content: `New Website Launch

We're excited to announce that Recovery Room will be launching its new website in May 2026! This next step reflects our continued growth and commitment to building from the ground up with intention. The site will serve as a central hub for our community highlighting upcoming gatherings, resources, programming, and ways to stay connected and get involved. Participants will now be able to create Member Profiles to support and improve community engagement across the organization.

This platform will help us deepen our impact and continue creating a space where Black men can realign, grow, and thrive together.


New Committee Chairmembers

Our six Committee Chairmembers for the 2026–2027 program year are officially confirmed! We extend a special thank you to everyone who expressed interest and submitted their candidacy. We're excited to welcome this new body of leadership into our programming and look forward to the meaningful work ahead.

Stay tuned for additional updates and communications in the coming weeks regarding upcoming programming and community engagement opportunities. In the meantime, drop the team a congratulatory message and let's continue celebrating the future of Recovery Room—together!

2026-2027 R&R Committee Chairmembers:

Recruitment - Reginald Ready
Support membership growth and participation across monthly gatherings and community events. Maintain an active participant roster to strengthen tracking, communication, and overall engagement.
📧 r_ready@hotmail.com

Community Engagement - Kmt Shockley, PhD
Cultivate partnerships, amplify visibility, and support community-based events to expand reach and deepen impact.
📧 kshockle@yahoo.com

Mentorship - Orlance Shirley
Facilitate connections among new and engaging brothers, supporting peer mentorship and fostering a supportive environment.
📧 a4lance@gmail.com

Professional Development - Anthony Carter
Design and support workshops and learning opportunities that foster career growth, skill development, and advancement among participants and volunteers.
📧 phpanthonycarter@gmail.com

IT/Marketing - Ihkeem Ma'at
Lead our technology and marketing initiatives to expand the Recovery Room's digital presence and impact.
📧 mypromsetome@gmail.com

Fundraising - Herman Pryor Jr., Ed.D.
Lead all fundraising efforts to support R&R programming and building fund campaigns.
📧 hpryor@recoveredbrother.com

The first Quarterly Committee Chair Roundtable will take place in May 2026 (date TBD).

Each Committee Chairmember appointment will last for a one-year term, with the option to renew or rotate as needed. Appointments for the 2026 calendar year will begin on May 1, 2026.

All brothers are welcome to participate in any of the available committees at will. For more info on how you can support, please contact a designated Committee Chairmember.`
            }
        ]
    };

    return (
        <div className="min-h-screen bg-[#3D4435]">
            <MainNav />
            
            <main className="pt-32 pb-24 px-6">
                <div className="max-w-4xl mx-auto">
                    {/* Back Button */}
                    <Link to="/community/newsletter" className="inline-flex items-center gap-2 text-[#C9A227] hover:text-[#E8D48A] mb-8 transition-colors">
                        <ArrowLeft className="w-4 h-4" />
                        Back to Newsletters
                    </Link>

                    {/* Newsletter Content */}
                    <Card className="bg-[#4A5240] border-[#C9A227]/50 overflow-hidden">
                        <div className="h-2 bg-gradient-to-r from-[#C9A227] to-[#E8D48A]" />
                        <CardContent className="p-8">
                            {/* Header */}
                            <div className="text-center mb-8 pb-8 border-b border-[#5A6350]">
                                <p className="text-[#C9A227] text-sm uppercase tracking-[0.2em] font-medium mb-2">
                                    {newsletter.month} • {newsletter.volume}
                                </p>
                                <h1 className="text-4xl font-bold text-white font-['Playfair_Display'] mb-3">
                                    {newsletter.title}
                                </h1>
                                <p className="text-[#A0A0A0] italic text-lg">
                                    Elevating safe spaces for Black men
                                </p>
                                <p className="text-[#C9A227] font-medium mt-4 text-xl">
                                    "{newsletter.tagline}"
                                </p>
                            </div>

                            {/* From the Founder's Desk */}
                            <div className="pb-8 mb-8 border-b border-[#5A6350]">
                                <h2 className="text-2xl font-bold text-[#C9A227] font-['Playfair_Display'] mb-6">
                                    From the Founder's Desk
                                </h2>
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/3 flex-shrink-0">
                                        <img 
                                            src={newsletter.founderImage} 
                                            alt="Dr. Herman I. Pryor Jr., Ed.D."
                                            className="w-full max-w-[250px] mx-auto rounded-xl object-cover"
                                        />
                                    </div>
                                    <div className="md:w-2/3 text-[#A0A0A0] whitespace-pre-line leading-relaxed">
                                        {newsletter.foundersDesk}
                                    </div>
                                </div>
                            </div>

                            {/* Other Newsletter Sections */}
                            <div className="space-y-8">
                                {newsletter.sections.map((section, idx) => (
                                    <div key={idx} className="pb-8 mb-8 border-b border-[#5A6350] last:border-0 last:mb-0 last:pb-0">
                                        <h2 className="text-2xl font-bold text-[#C9A227] font-['Playfair_Display'] mb-2">
                                            {section.title}
                                        </h2>
                                        {section.subtitle && (
                                            <p className="text-white text-xl font-semibold mb-4">{section.subtitle}</p>
                                        )}
                                        {section.image && (
                                            <img 
                                                src={section.image} 
                                                alt={section.subtitle || section.title}
                                                className={`rounded-xl mb-6 ${section.subtitle ? 'w-72 h-72 object-cover object-top mx-auto' : 'w-full max-w-2xl mx-auto'}`}
                                            />
                                        )}
                                        <div className="text-[#A0A0A0] whitespace-pre-line leading-relaxed">
                                            {section.content}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Footer */}
                            <div className="text-center mt-8 pt-8 border-t border-[#5A6350]">
                                <Link to="/community/newsletter">
                                    <Button className="bg-[#C9A227] hover:bg-[#B8922A] text-[#3D4435] font-semibold px-8">
                                        Back to All Newsletters
                                    </Button>
                                </Link>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </main>

            <MainFooter />
        </div>
    );
};

export default NewsletterApril2026Page;
